import { render, staticRenderFns } from "./ComboboxMultipleInput.vue?vue&type=template&id=088bd67d"
import script from "./ComboboxMultipleInput.vue?vue&type=script&lang=js"
export * from "./ComboboxMultipleInput.vue?vue&type=script&lang=js"
import style0 from "./ComboboxMultipleInput.vue?vue&type=style&index=0&id=088bd67d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VCombobox,VRow})
